/* import __COLOCATED_TEMPLATE__ from './main-panel.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type AnalyticsService from '@ebiz/ember-aditools-analytics/services/aditools-analytics';
import type SiteService from '@ebiz/ember-aditools-site/services/aditools-site';
import type CircuitService from '../services/circuit';
import type { IndexRouteModel } from '../routes/index';

const K_OUTPUT_TAB = 0,
  K_TABLE_TAB = 1,
  K_DEBUG_TAB = 2;

interface MainPanelSignature {
  Args: {
    model: IndexRouteModel;
    selectedTab: number;
    openDialog: (name: string) => void;
    selectedPartChanged: () => void;
  };
}

export default class MainPanel extends Component<MainPanelSignature> {
  @service('aditools-analytics') declare analytics: AnalyticsService;
  @service('aditools-site') declare siteconfig: SiteService;
  @service declare circuit: CircuitService;

  get isOutputTab() {
    return this.args.selectedTab === K_OUTPUT_TAB;
  }
  get isTableTab() {
    return this.args.selectedTab === K_TABLE_TAB;
  }
  get isDebugTab() {
    return this.args.selectedTab === K_DEBUG_TAB;
  }

  @action openBlockDiagramOnEnter(event: KeyboardEvent) {
    if ((event.key === 'Enter' || event.key === ' ') && this.args.openDialog) {
      this.args.openDialog('block_diagram');
    }
  }
}

/*
          <AditoolsSectionSubheader
            data-qa-element="simdds_signals_to_display_header"
            @title={{t "main-panel.signals_display_header"}}
            @enableModalIcon={{true}}
            @icon="help"
            @qaName="signals"
            @closeButtonText={{t "dialog.close_button"}}
            @tooltip={{t "dialog.signals_display_help.header"}}
            @modalTitle={{t "dialog.signals_display_help.header" htmlSafe=true}}
            @modalMessage={{t 
              "dialog.signals_display_help.content"  
              siteUrl=(get this.siteconfig 'SiteUrl') 
              eloqua0=this.circuit.nonDDSQueryString 
              content=(get this.siteconfig 'ContentPrefix') 
              htmlSafe=true
            }}
          />
*/
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    MainPanel: typeof MainPanel;
  }
}
